import React from "react";
import "../assets/styles/HomePage.css";



function PrivacyPolicy() {
  return (
  <>

    <div className="home-page">    
      <div className="recommended-use-cases">
        <h1>Privacy Policy 🔒</h1>
        <p><strong> Updated: 01.03.2025 </strong></p>
        <p>
          Welcome to download-videos ("Platform," "we," "our," or "us"). This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our services. Please read it carefully. ✅
        </p>
        <h2>1. Information We Collect 📊</h2>
        <p>
          We collect and process the following types of information:
          <h3> a)- Information You Provide 📝</h3>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>Account registration details (e.g., name, email, password)</li>
            <li>Uploaded content (e.g., audio/video files for transcription)</li>
            <li>Any communications with us (e.g., customer support inquiries)</li>
          </ul>
          <h3> b)- Information We Collect Automatically 🚀</h3>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li> Usage data (e.g., pages visited, features used, interaction data)</li>            
            <li> Cookies and tracking technologies (see Cookies Policy below) as we are using Google-Signin services</li>
          </ul>
          <h3> c)- Information from Third-Party Sign-In Services 🔗</h3>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li> If you sign in with Google, we may access your email and profile information to create and manage your account.</li>            
          </ul>
        </p>

        <h2>2. How We Use Your Information ⚙️</h2>
        <p>
          We use the collected data for the following purposes:
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>To provide and improve our transcription services 🎙️ </li>
            <li>To personalize user experience and enhance platform performance</li>
            <li>To respond to inquiries and provide customer support 📩</li>
            <li>To enforce our Terms of Use and ensure security 🔐</li>
            <li>To analyze usage trends and improve our features 📈</li>
          </ul>
        </p>

        <h2>3. How We Share Your Information 🔄</h2>
        <p>
          We do not sell, trade, or rent your personal data. However, we may share information with:
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li><strong>Service Providers</strong>: Third parties that help us operate and improve our Platform (e.g., cloud storage, analytics, security services)</li>
            <li><strong>Legal Compliance</strong>: If required by law or to protect our rights and prevent fraud ⚖️</li>
            <li><strong>Business Transfers</strong>: In case of a merger, sale, or acquisition, your information may be transferred 📁</li>
          </ul>
        </p>          

        <h2>4. Data Retention & Account Deletion 🗑️</h2>
        <p>
          By using the Platform, you agree that you will:
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>We retain user data as long as necessary for service provision and legal compliance</li>
            <li>Users may <strong>request complete account deletion</strong> at any time from their account settings</li>
            <li>Upon deletion, all user data, including transcripts and account details, will be <strong>permanently removed</strong></li>
          </ul>
        </p>          

        <h2>5. Security Measures 🔐</h2>
        <p>
          We implement industry-standard security measures to protect user data, including:
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li> Encryption of stored and transmitted data 🛡️ </li>
            <li> Access controls and authentication mechanisms 🔑</li>
            <li> Regular security audits and monitoring 🕵️‍♂️</li>
          </ul>
        </p>          

        <h2>6. Cookies & Tracking Technologies 🍪</h2>
        <p>
          We use cookies and similar tracking technologies to:
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li> Remember user preferences and enhance experience</li>
            <li> Analyze site performance and user interactions 📊</li>
            <li> Improve our services based on behavioral data. Users can <strong>disable cookies</strong> via browser settings but may experience reduced functionality.</li>
          </ul>
        </p>          

        <h2>7. Your Rights & Choices ✊</h2>
        <p>
          Depending on your location, you may have the following rights:
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li> Access & Correction: Request access to or correction of your data.</li>
            <li> Opt-Out: Disable cookies or unsubscribe from marketing communications.</li>
            <li> Data Portability: Request a copy of your data in a structured format.</li>
          </ul>
        </p>          

        <h2>8. Changes to This Policy 🔄</h2>
        <p>
          We may update this Privacy Policy periodically. We will notify users of major changes via email or platform announcements. Continued use of our Platform signifies acceptance of the updated policy.
        </p>          

        <h2>9. Contact Information 📧</h2>
        <p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>For any questions regarding these Terms, please contact us <a style={{textDecoration: "none", color: "#f1c40f"}} href="https://chaperoneai.net/contact" target="_blank" rel="noopener noreferrer"> here</a>. 📩</li>
            <li>By using our Platform, you confirm that you have read, understood, and agreed to these Terms of Use. ✅</li>
          </ul>
        </p>
        

      </div>
    </div>
    </>
  );
}

export default PrivacyPolicy;
